export const getCurrentRegions = ({ region = {} } = {}) => region;

export default getCurrentRegions;
